// src/components/Services.js
import React from "react";
import Layout from "./Layout";
import "./Services.css";

function Services() {
  return (
    <Layout>
      <div className="services-container">
        <h1>Our Services</h1>

        <section className="service">
          <h2>Tender Tracker Service</h2>
          <p>
            Our Tender Tracker Service compiles government tenders from various official portals, including GeM, state
            government portals, and CPPP, and presents them in a user-friendly, searchable format. Leveraging advanced AI
            technology, we automate data gathering and curation to create an interface as simple and effective as an
            Excel file. This allows you to search, filter, and manage tenders efficiently, saving valuable time and
            effort.
          </p>
        </section>

        {/* NEW (2nd): Results Tracker */}
        <section className="service">
          <h2>Results Tracker (GeM Bid Results + GeM all Contracts Dashboard + Non-GeM Tender Results)</h2>
          <p>
            Our Results Tracker helps you go beyond “tenders” and track what actually happened after the bid closed.
            We provide three dedicated experiences—one for GeM bid results, second for non-GeM tender results (CPPP and
            other portals) and third for all GeM contracts- Direct Orders and Bids. Across these result pages, you can quickly view winners, participants, quoted prices,
            comparative pricing, and key outcome details wherever available. This makes it easy to benchmark your
            pricing, study competitor participation patterns, identify repeat winners, and spot category/department
            trends over time—turning scattered result pages into a structured, searchable database for competitor
            intelligence and strategy planning.
          </p>
        </section>

        {/* NEW (3rd): TenderMaker / Bid Analyzer / Bid Studio */}
        <section className="service">
          <h2>TenderMaker Suite (TenderMaker, Bid Analyzer &amp; Bid Studio)</h2>
          <p>
            The TenderMaker Suite is built to simplify bid preparation end-to-end—especially the messy “PDF + annexures +
            forms” part that typically eats up hours. In Bid Studio, you can keep all bid documents in one workspace,
            merge/split PDFs, organize annexures, and apply signature/stamp/letterhead as required—so your team doesn’t
            have to jump between multiple tools or rely on external utilities to merge PDFs etc. 
            Bid Analyzer adds AI-based bid analysis that converts tender documents into clear bid requirements, checklists, 
            and submission steps, helping you quickly identify mandatory clauses, eligibility conditions, documents to attach, 
            and risk/compliance flags. With reusable company documents stored in your Profile Vault (GST/PAN, authorizations, 
            signatures, stamp, letterheads, etc.), you can generate consistent, submission-ready drafts faster, 
            reduce repetitive work, and improve overall compliance quality across bids.
          </p>
        </section>

        <section className="service">
          <h2>Standard and Customised Reports</h2>
          <p>
            We offer both standard and customized reports to provide comprehensive insights into the government
            procurement market. Our reports utilize AI-driven data analysis to deliver in-depth market intelligence,
            including product/service analysis and other critical metrics. These reports equip you with the knowledge
            needed to make informed decisions and strategically navigate government procurement opportunities.
          </p>
        </section>

        <section className="service">
          <h2>GeM Training</h2>
          <p>
            We conduct hands-on training to help teams use the Government e-Marketplace (GeM) confidently end-to-end:
            account setup and verification, OEM/brand authorization, catalog listing, bid discovery and filtering, bid/RA
            participation, compliance and documentation, order processing, and post-order workflows. The program blends
            practical walkthroughs, real examples from your categories, checklists/SOP templates, and Q&amp;A. Available
            in three formats— A. Corporate cohorts (multiple participants), B. 1-on-1 personal coaching, and C. open
            batches—so your team can quickly become GeM-ready and self-sufficient.
          </p>
        </section>

        <section className="service">
          <h2>Customised Consulting Services</h2>
          <p>
            For personalized, human-interfaced consulting services, our sister company, <strong>GEM MANAGERS</strong>{" "}
            (<a href="https://www.gemmanagers.com" target="_blank" rel="noreferrer">
              www.gemmanagers.com
            </a>
            ), is ready to assist. We offer tailored solutions to meet unique client requirements, whether they involve
            advanced procurement strategy, direct consultation, or specialized market analysis. Get in touch at{" "}
            <a href="mailto:sales@gemmanagers.com">sales@gemmanagers.com</a> or call{" "}
            <strong>+91-8655654720</strong>.
          </p>
        </section>
      </div>
    </Layout>
  );
}

export default Services;
